const initBackToTopLink = () => {
    const backToTopLinks = document.getElementsByClassName('back-to-top-link');
    Array.from(backToTopLinks).forEach(link => {
        link.addEventListener('click', () => {
            Velocity(document.body, 'scroll', {duration: 400});
        });
    });
};

export default initBackToTopLink;
